// these should match QMAnnotationType on the server
export default {
    pause: {
        iconClassName: "fa fa-pause",
        iconName: "control-pause",
        labelKey: "annotation.pauseTitle",
    },
    securepause: {
        iconClassName: "fa fa-pause",
        iconName: "control-pause",
        labelKey: "annotation.securePauseTitle",
    },
    hold: {
        iconClassName: "fa fa-asterisk",
        iconName: "fa/asterix-regular",
        labelKey: "annotation.holdTitle",
    },
    bookmark: {
        iconClassName: "fa fa-bookmark",
        iconName: "fa/bookmark-regular",
        labelKey: "annotation.bookmarkTitle",
    },
    unknown: {
        iconClassName: "fa fa-asterisk",
        iconName: "fa/asterix-regular",
        labelKey: "annotation.unknownTitle",
    },
    combinedannotations: {
        iconClassName: "fa fa-ellipsis-h combined-playback-event",
        iconName: "fa/ellipsis-regular",
        className: "combined-playback-event",
        labelKey: "annotation.events",
    },
};
